/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetDashboardPraetorSparklineParams = zod.object({
	start: zod.string(),
	end: zod.string()
});

export type GetDashboardPraetorSparklineParams = zod.input<
	typeof GetDashboardPraetorSparklineParams
>;
export type GetDashboardPraetorSparklineParamsOutput = zod.output<
	typeof GetDashboardPraetorSparklineParams
>;
